import { render, staticRenderFns } from "./FormBuilderPreview.vue?vue&type=template&id=e04d84d2&scoped=true"
import script from "./FormBuilderPreview.vue?vue&type=script&lang=js"
export * from "./FormBuilderPreview.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderPreview.vue?vue&type=style&index=0&id=e04d84d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04d84d2",
  null
  
)

export default component.exports